import React, { useState, useEffect } from "react";
import { Input } from "antd";

import styled from "styled-components/macro";

const Wrapper = styled.div`
  .btns {
    margin-top: 26px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  h1 {
    font-size: 16px;
    margin-bottom: 22px;
    text-align: center;
  }
`;

const CancelButton = styled.button`
  width: 100%;
  max-width: 200px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.04);
  border: solid 1px #d0d6db;
  background-color: #ffffff;
  color: #747d84;
  font-size: 14px;
  cursor: pointer;
`;

const SubmitButton = styled.button`
  width: 100%;
  max-width: 200px;
  height: 40px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.04);
  background-color: ${props => (props.disabled ? "#f7f9fa" : "#3D64FF")};
  color: ${props => (props.disabled ? "#d0d6da" : "white")};
  font-size: 14px;
  cursor: pointer;
  border: none;
  font-style: ${props => props.disabled && "italic"};
`;

function RejectForm({ onSubmit, onCancel, companies, t }) {
  const [rejectReason, setRejectReason] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    setError("");
  }, [rejectReason]);

  const submit = () => {
    if (!rejectReason.length) {
      return setError(t("form:emptyFieldValidation"));
    }
    onSubmit(rejectReason);
  };

  return (
    <Wrapper data-test="reject-form">
      <h1>{t("vinculations:reject.sure")}</h1>
      <p className="description">
        {t("vinculations:reject.studentsWontSeeFrom")}
        <strong>
          {companies.length === 1
            ? companies[0].name
            : t("vinculations:reject.pluralcompanies", {
                ammount: companies.length
              })}
        </strong>
        .
      </p>
      <strong style={{ marginBottom: 8, display: "block" }}>
        * {t("vinculations:reject.describeReason")}
      </strong>
      <Input.TextArea
        type="text"
        value={rejectReason}
        autoSize={{
          minRows: 7
        }}
        onChange={e => {
          setRejectReason(e.target.value);
        }}
        data-test="reject-form-input"
      />
      {error && <p style={{ color: "red" }}>* {error}</p>}
      <div className="btns">
        <CancelButton style={{ marginRight: 8 }} onClick={onCancel}>
          {t("global:cancel")}
        </CancelButton>
        <SubmitButton
          data-test="submit-reject-form"
          type="submit"
          onClick={submit}
        >
          {t("global:send")}
        </SubmitButton>
      </div>
    </Wrapper>
  );
}

export default RejectForm;
